import { ImagePlus, Pencil } from 'lucide-react'

import { TranslationComponent } from '@/components/translation'
import { Button } from '@/components/ui/button'
import useTranslator from '@/hooks/translation'
import { cn } from '@/lib/utils'

import { UploadCardImagePreviewProps } from './types'

export function UploadCardImagePreview({
  imgPreview,
  onEdit,
}: UploadCardImagePreviewProps) {
  const { getTranslation } = useTranslator()

  const isInteractive = Boolean(onEdit)

  return (
    <div
      className={cn(
        'group relative h-[8.75rem] w-full cursor-pointer overflow-hidden rounded-lg bg-muted',
        !imgPreview && 'border-2 border-dashed',
      )}
      role={isInteractive ? 'button' : undefined}
      aria-label={isInteractive ? 'Edit or upload image' : undefined}
    >
      {imgPreview ? (
        <>
          <img
            src={imgPreview}
            alt="Image preview"
            className="h-full w-full object-cover"
          />

          <div
            className={cn(
              'absolute inset-0 top-0 hidden items-center justify-center gap-4 rounded-t-[0.64rem] p-4 backdrop-blur-sm hover:bg-fintalk/10 group-hover:flex',
            )}
          >
            <Button
              type="button"
              size="icon"
              className="rounded-full bg-background text-foreground hover:bg-background/80"
              onClick={onEdit}
              aria-label="Edit image"
            >
              <Pencil />
            </Button>
          </div>
        </>
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-between gap-2 p-2 py-3 text-muted-foreground">
          <p className="font-light">
            {
              <TranslationComponent
                i18nKey="common.files.uploadImage.dragAndDropOrBrowse"
                components={{
                  bold: <span className="font-bold" />,
                }}
              />
            }
          </p>

          <div className="rounded-lg border bg-background p-2">
            <ImagePlus strokeWidth={1} className="h-10 w-10" />
          </div>

          <p className="font-light">
            {getTranslation('common.files.uploadImage.supported')}
          </p>
        </div>
      )}
    </div>
  )
}
